<template>
  <div>
    <br />
    <h1 class="text-xs-center">Advanced Settings</h1>
    <v-layout row wrap justify-center>
      <v-flex xs12 sm10 md8 lg6 pa-2>
        <v-list two-line>
          <v-list-tile :to="{ name: 'advanced-hours-of-operation-templates' }" ripple>
            <v-list-tile-action>
              <v-icon>fal fa-business-time</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Hours Of Operation Templates</v-list-tile-title>
              <v-list-tile-sub-title>Manage reusable operational-hours templates</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider />
          <v-list-tile :to="{ name: 'advanced-check-offline-buses' }" ripple>
            <v-list-tile-action>
              <v-icon>fal fa-satellite-dish</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Check Offline Buses</v-list-tile-title>
              <v-list-tile-sub-title>Configure offline bus detection notifications</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider />
          <v-list-tile :to="{ name: 'advanced-payout-settings' }" ripple>
            <v-list-tile-action>
              <v-icon>fal fa-money-check-edit-alt</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Payout Settings</v-list-tile-title>
              <v-list-tile-sub-title>Manage global payout fee settings by agency</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider />
          <v-list-tile :to="{ name: 'advanced-reports' }" ripple>
            <v-list-tile-action>
              <v-icon>fal fa-chart-line</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Reports</v-list-tile-title>
              <v-list-tile-sub-title>Monitor report workers and request reports on demand</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider />
          <v-list-tile :to="{ name: 'advanced-vehicle-kwh-usage' }" ripple>
            <v-list-tile-action>
              <v-icon>fal fa-bolt</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Vehicle KWh Usage</v-list-tile-title>
              <v-list-tile-sub-title>Enter daily vehicle charging usage</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider />
          <v-list-tile :to="{ name: 'advanced-revenue-exclusion-periods' }" ripple>
            <v-list-tile-action>
              <v-icon>fal fa-calendar-times</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Revenue Exclusion Periods</v-list-tile-title>
              <v-list-tile-sub-title>Manage dates excluded from transportation owner revenue and fees</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider />
          <v-list-tile :to="{ name: 'advanced-ev-chargers' }" ripple>
            <v-list-tile-action>
              <v-icon>fal fa-charging-station</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>EV Chargers</v-list-tile-title>
              <v-list-tile-sub-title>Manage charger provisioning, location, and credentials</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import src from './src'
export default src
</script>
